import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-misidentified-face-close-dialog',
  templateUrl: 'misidentified-face-close-dialog.component.html',
  standalone: false,
})
export class MisidentifiedFaceCloseDialogComponent {
  dialogRef = inject<MatDialogRef<MisidentifiedFaceCloseDialogComponent>>(MatDialogRef);

  onNoClick(): void {
    this.dialogRef.close();
  }
}
